module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av11-18ec9d4485aa9b4732479473d6cb112f.jpg";